import { createHandlerChainRunner, HandlerWithResult } from "@insite/client-framework/HandlerCreator";

type HandlerType = HandlerWithResult<boolean, string>;

export const DispatchSetIsSearchPage: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductList/SetIsSearchPage",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetIsSearchPage];

const setIsSearchPage = createHandlerChainRunner(chain, "SetIsSearchPage");
export default setIsSearchPage;
